import React, { useCallback, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Navbar, SideBar } from "./Layouts/MainPage";
import { SidebarItem } from "./Layouts/MainPage/SideBar";
import { useTranslation } from "react-i18next";
import {
  GetAccess,
  GetDashboardRole,
  GetMultipleAccess,
} from "./Components/Utils/roles";
import {
  BookOpenCheck,
  ClipboardCheck,
  Contact,
  FireExtinguisher,
  LayoutDashboard,
  LayoutList,
  ListTodo,
  Mails,
  ReceiptText,
  ReceiptTextIcon,
  ScrollText,
  SquareKanban,
  SquareLibrary,
  Users,
  UserSearch,
} from "lucide-react";

const App = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const handleKeyPress = useCallback((event) => {
    if (event.key === "Escape") {
      navigate(-1);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);

  function isActiveFun(x) {
    let actualPath = location.pathname.split("/")[1];

    let linkPath = "";
    if (x?.hasSubMenu) {
      if (x?.subMenu) {
        let y = x.subMenu[0].link;
        let z = y.split("/")[0];
        linkPath = z;
      }
    } else {
      linkPath = x?.link;
    }

    if (linkPath.includes(actualPath)) {
      return true;
    } else {
      return false;
    }
  }

  const navItem = [
    {
      icon: <LayoutDashboard size={16} />,
      title: "Dashboard",
      hasSubMenu: false,
      hasAccess: true,
      link: GetDashboardRole("")
        ? "/dashboard"
        : GetDashboardRole("sales")
        ? `/dashboard/sales`
        : GetDashboardRole("procurement")
        ? `/dashboard/procurement`
        : GetDashboardRole("store")
        ? `/dashboard/stores`
        : `/dashboard`,
    },

    {
      link: GetAccess("clients_view")
        ? `/client-management/clients`
       
        : "#",
      icon: (
        <>
          <Users size={16} />
        </>
      ),
      title: "Clients",
      // access: GetAccess("client_management_module"),
      hasAccess: ["clients_view"],
      hasSubMenu: false,
      subMenu: [],
    },

       {
      link: GetAccess("quotation_view") ? `/quotation/quote`: "#",
      icon: (
        <>
          <ReceiptText size={16} />
        </>
      ),
      title: "Quotation",
      hasAccess: ["quotation_view"],
      // access: GetAccess("Invoice_module"),
      hasSubMenu: false,
      subMenu: [],
    },
     {
      link: GetAccess("survey_view")
        ? `/Contract-management/survey-report`
        : GetAccess("contracts_view")
        ? `/Contract-management/contracts`
        :GetAccess("commissioning_schedules_view")
        ? `/testingAndcommisioning/schedules`
        :GetAccess("fire_extinguisher_view")
        ? `/collectionAndreturn/fireExtinguisher`
        : GetAccess("fire_suppression_view")
        ? `/collectionAndreturn/fireSuppression`
        : "#",
      icon: (
        <>
          <ReceiptTextIcon size={16} />
        </>
      ),
      title: "Contracts",
      // access: GetAccess("client_management_module"),
      hasAccess: ["survey_view", "contracts_view","commissioning_schedules_view","fire_extinguisher_view","fire_suppression_view"],
      hasSubMenu: false,
      subMenu: [],
    },
  
 {
      link: GetAccess("team_view")
        ? `/teammember/team`
        : GetAccess("team_availability")
        ? `/teammember/availability`
        : "#",
      icon: (
        <>
          <UserSearch size={16} />
        </>
      ),
      title: "Team",
      hasAccess: ["team_view", "team_availability"],
      access: GetAccess("team_module"),
      hasSubMenu: false,
    },
    {
      link: GetAccess("inspection_calendar_view")
        ? `/inspection/schedule`
        : GetAccess("inspection_schedule_view")
        ? `/inspection/calender`
        : "#",
      icon: (
        <>
          <ClipboardCheck size={16} />
        </>
      ),
      title: "Inspection",
      hasAccess: ["inspection_calendar_view", "inspection_schedule_view"],
      access: GetAccess("inspection_module"),
      hasSubMenu: false,
    },
    // {
    //   link: GetAccess("commissioning_schedules_view")
    //     ? `/testingAndcommisioning/schedules`
    //     : "#",
    //   icon: (
    //     <>
    //       <BookOpenCheck size={16} />
    //     </>
    //   ),
    //   title: "Commissioning",
    //   hasAccess: ["commissioning_schedules_view"],
    //   access: GetAccess("GetAccess("commissioning_schedules_view")
    //     ? `/testingAndcommisioning/schedules`"),
    //   hasSubMenu: false,
    //   subMenu: [],
    // },

    // {
    //   icon: (
    //     <>
    //       <FireExtinguisher size={16} />
    //     </>
    //   ),
    //   link: GetAccess("fire_extinguisher_view")
    //     ? `/collectionAndreturn/fireExtinguisher`
    //     : GetAccess("fire_suppression_view")
    //     ? `/collectionAndreturn/fireSuppression`
    //     : "#",
    //   title: "Refilling",
    //   // access: GetAccess("refilling_module"),
    //   hasAccess: ["fire_extinguisher_view", "fire_suppression_view"],
    //   hasSubMenu: false,
    //   subMenu: [],
    // },

    {
      icon: <SquareKanban size={16} />,
      link: GetAccess("client_tickets_view")
        ? `/tickets/client-tickets`
        : GetAccess("support_tickets_view")
        ? `/tickets/support-tickets`
        : "#",
      title: "Tickets",
      hasAccess: ["client_tickets_view", "support_tickets_view"],
      hasSubMenu: false,
      subMenu: [],
    },

    {
      link: GetAccess("invoice_out_view") ? `/invoice/invoice-outgoing` : "#",
      icon: (
        <>
          <ReceiptText size={16} />
        </>
      ),
      title: "Invoice",
      hasAccess: ["invoice_out_view"],
      // access: GetAccess("Invoice_module"),
      hasSubMenu: false,
      subMenu: [],
    },

    {
      icon: <ListTodo size={16} />,
      link: GetAccess("mytasks_view")
        ? `/tasks/my-tasks`
        : GetAccess("tasks_view")
        ? `/tasks/all-tasks`
        : "#",

      title: "Tasks",
      hasAccess: ["mytasks_view", "tasks_view"],
      hasSubMenu: false,
      subMenu: [],
    },

    {
      icon: <SquareLibrary size={16} />,
      title: "Forms",
      link: GetAccess("insforms_view")
        ? `/forms/insforms`
        : "#",

      hasAccess: ["forms_view","insforms_view"],
      hasSubMenu: false,
      subMenu: [],
    },
    {
      link: GetAccess(
        "report_module",
        "report_client_management",
        "report_client",
        "report_survey",
        "report_contract",
        "report_inspection",
        "report_inspection_scheule",
        "report_commisioning",
        "report_commisioning_schedule",
        "report_refilling",
        "report_refilling_ext",
        "report_refilling_sup",
        "report_ticket",
        "report_ticket_client",
        "report_ticket_support",
        "report_task",
        "report_task_task",
        "report_invoice_outgoing",
        "report_invoice_outgoing"
      )
        ? `/report`
        : "#",
      icon: (
        <>
          <ScrollText size={16} />
        </>
      ),
      title: "Report",
      hasAccess: [
        "report_module",
        "report_client_management",
        "report_client",
        "report_survey",
        "report_contract",
        "report_inspection",
        "report_inspection_scheule",
        "report_commisioning",
        "report_commisioning_schedule",
        "report_refilling",
        "report_refilling_ext",
        "report_refilling_sup",
        "report_ticket",
        "report_ticket_client",
        "report_ticket_support",
        "report_task",
        "report_task_task",
        "report_invoice_outgoing",
        "report_invoice_outgoing",
      ],
      // access: GetAccess("report_module"),
      hasSubMenu: false,
      subMenu: [],
    },
    {
      link: GetAccess("email_view") ? `/email/email-sent` : "#",

      icon: <Mails size={16} />,
      title: "E-mail",
      hasAccess: ["email_view"],
      hasSubMenu: false,

      subMenu: [],
    },

    {
      link: GetAccess("consultants_view")
        ? `/contacts/consultants`
        : GetAccess("contacts_view")
        ? `/contacts/main-contractors`
        : GetAccess("installers_view")
        ? `/contacts/installers`
        : GetAccess("suppliers_view")
        ? `/contacts/suppliers`
        : "#",
      icon: <Contact size={16} />,

      title: "Contacts",
      hasAccess: [
        "consultants_view",
        "contacts_view",
        "installers_view",
        "suppliers_view",
      ],
      hasSubMenu: false,
    },
  ];

  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className=" w-full h-screen bg-slate-100 flex justify-start items-center overflow-hidden">
      <div className=" hidden w-16 z-[997] lg:block">
        {/* <div
      className={`h-screen bg-gray-900 text-white transition-all duration-300 ${
        isHovered ? "w-64" : "w-16"
      } fixed left-0 top-0 flex flex-col p-2`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="flex flex-col space-y-4 mt-4">
        <SidebarItems icon={"H"} label="Home" isHovered={isHovered} />
        <SidebarItems icon={"U"} label="Profile" isHovered={isHovered} />
        <SidebarItems icon={"S"} label="Settings" isHovered={isHovered} />
      </div>
    </div> */}
        <SideBar>
          {navItem &&
            navItem.map((item, idx) => {
              return (
                <>
                  {(item?.hasAccess == true ||
                    GetMultipleAccess(item?.hasAccess || [])) && (
                    <SidebarItem
                      icon={item?.icon}
                      text={t(item?.title)}
                      hasSubMenu={item?.hasSubMenu}
                      subItem={item?.subMenu}
                      link={item?.link}
                      active={isActiveFun(item)}
                      key={idx}
                    />
                  )}
                </>
              );
            })}
        </SideBar>
      </div>
      <div className=" w-full h-[100vh]  ">
        <div className=" w-full h-[59px] bg-white z-50 shadow-lg">
          <Navbar />
        </div>
        <div className=" w-full h-[calc(100vh-77px)]  overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default App;

function SidebarItems({ icon, label, isHovered }) {
  return (
    <div className="flex items-center space-x-4 p-2 rounded-lg hover:bg-gray-800 cursor-pointer">
      <span className="text-xl">{icon}</span>
      {isHovered && <span className="text-sm transition-opacity">{label}</span>}
    </div>
  );
}
